import { render } from "./HeaderComp.vue?vue&type=template&id=87a8da0e"
const script = {}

import exportComponent from "/home/lislis/git/lislis/adf-cd/cd-client/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])